import { createContext } from 'react';
import type { AuthUser } from '@/types';

export interface AuthContextValue {
  isAuthenticated: boolean;
  loading: boolean;
  user: AuthUser | null;
  login: (
    username: string,
    password: string,
  ) => Promise<{
    user: AuthUser;
    requirePasswordChange: boolean;
  }>;
  logout: () => Promise<void>;
  setUserFromPortal: (user: AuthUser) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
